import AVAILABLE_LANGUAGES_L from "./languages"
import CONTENT_LANGUAGES_L from "./lanuages-content"

export const CONTENT_LANGUAGES = CONTENT_LANGUAGES_L
export const AVAILABLE_LANGUAGES = AVAILABLE_LANGUAGES_L
